<template>
  <div data-testid="sbx-pcc_merchSubCategoryV4" class="sbx-pcc_merchSubCategoryV4 mSubCat4" v-if="items && items.length">
    <div class="mSubCat4_heading">
      <h3 class="mSubCat4_title" :class="{ 'has-sub': this.subtitle }" v-if="this.title">{{ this.title }}</h3>
      <p class="mSubCat4_subtitle" v-if="this.subtitle">{{ this.subtitle }}</p>
    </div>
    <div class="mSubCat4__items" data-testid="sbx-pcc_merchSubCategoryV4-items" v-if="!isMobile">
      <merch-sub-category-v4-base
        v-for="(item, index) in this.items"
        :key="`mSubCatV4-${index}`"
        :item="item"
        :index="index"
        :screenSize="screenSize"
      />
    </div>
    <div v-if="isMobile" class="sbx-pcc_merchSubCategoryV4 mSubCat4-carousel" data-testid="sbx-pcc_merchSubCategoryV4-carousel">
      <agile :options="options">
        <merch-sub-category-v4-base
          v-for="(item, index) in this.items"
          :key="`mSubCatV4-${index}`"
          :item="item"
          :index="index"
          :screenSize="screenSize"
        />
      </agile>
    </div>
  </div>
</template>

<script>
import { merchSubCategoryV4 } from './index.js';
import { baseUrl } from '@/SharedFe/utils/urlUtils';
import { VueAgile } from 'vue-agile';
import MerchSubCategoryV4Base from './MerchSubCategoryV4BaseItem';
import { screenSizesMixin } from '../../SharedFe/utils/mixins/screenSizesMixin';

export default {
  name: 'merchSubCategoryV4',
  components: { MerchSubCategoryV4Base, agile: VueAgile },
  props: {
    ...merchSubCategoryV4.propTypes,
  },
  mixins: [screenSizesMixin],

  data() {
    return {
      baseUrl,
      options: {
        infinite: true,
        slidesToShow: 1,
        navButtons: true,
        dots: true,
      },
    };
  },

  computed: {
    isMobile() {
      return this.screenPx <= 767;
    },
  },
};
</script>
<style lang="scss">
@import '@/SharedFe/scss/variables.scss';
@import '@/SharedFe/scss/smartbox-icons.scss';
@import '@/SharedFe/scss/typography.scss';

$dotsActive: #343533;
$dotsColor: #c3c3c3;
$medium-up: 'only screen and (min-width: 768px)';

.mSubCat4 {
  margin: 0 auto;
  max-width: rem-calc(1230);
  width: 100%;

  &_title {
    margin: rem-calc(4) rem-calc(20) rem-calc(12) rem-calc(20);
    text-align: center;
    @media #{$wide-up} {
      margin: rem-calc(4) 0 rem-calc(20) 0;
    }

    &.has-sub {
      margin: rem-calc(4) rem-calc(20);
    }
  }

  &_subtitle {
    margin: rem-calc(4) rem-calc(20) rem-calc(8) rem-calc(20);
    text-align: center;
    @media #{$wide-up} {
      margin: rem-calc(4) rem-calc(20) rem-calc(20) rem-calc(20);
    }
  }

  &__items {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: rem-calc(20);
    margin-bottom: rem-calc(20);
  }

  &__link {
    text-decoration: none;
    position: relative;
    padding-left: 0;
    box-sizing: border-box;

    @media #{$medium-up} {
      width: calc(25% - 1rem);
    }

    @media #{$desktop-up} {
      &:hover {
        opacity: 0.7;
      }
    }
  }

  &__item-label {
    position: absolute;
    left: 0;
    bottom: rem-calc(21);
    margin: rem-calc(5 0);
    font-size: rem-calc(20);
    line-height: rem-calc(22);
    margin-bottom: rem-calc(5);
    font-weight: unset;
    font-family: $brand-font-medium;
    color: $collection-white;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);
    text-transform: uppercase;
    padding: 0 rem-calc(30);
    text-align: center;
    width: calc(100% - 60px);
    @media #{$desktop-up} {
      font-size: rem-calc(26);
      line-height: rem-calc(30);
      padding: 0 rem-calc(30);
      bottom: rem-calc(24);
    }
  }

  .mSubCatV4__image {
    width: 100%;
    max-width: rem-calc(293);
    border-radius: rem-calc(2);
  }
}

.mSubCat4-carousel {
  margin-left: rem-calc(16);

  .agile {
    overflow: hidden;

    &__nav-button {
      position: absolute;
      top: 37%;
      font-size: 0;
      border: none;
      background: transparent;
      width: 0;
      height: 0;
      cursor: pointer;

      &:before {
        @include si();
        color: $brand-primary-color-1;
        font-size: rem-calc(40);
        font-weight: bold;
      }

      &:hover,
      &:focus {
        &:before {
          color: $brand-primary-color-darker-10;
        }
      }

      &--prev {
        display: none;
      }

      &--next {
        right: rem-calc(40);

        &:before {
          content: si-('chevron-right');
          background-color: $collection-white;
          border-radius: rem-calc(5);
          height: rem-calc(50);
          line-height: rem-calc(50);
          font-size: rem-calc(28);
        }
      }
    }

    &__dots {
      padding: 0;
      margin: rem-calc(10) auto;
    }

    &__dot {
      margin: 0;
      padding: rem-calc(4);

      button {
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: block;
        height: rem-calc(8);
        font-size: 0;
        line-height: 0;
        margin: 0;
        padding: 0;
        transition-duration: 0.3s;
        width: rem-calc(8);
        background-color: $dotsColor;
      }

      &--current button {
        background-color: $dotsActive;
      }
    }

    &__slide {
      display: flex;
    }
  }

  .agile__list {
    width: 83%;
    overflow: initial;
  }

  .mSubCatV4__image {
    width: 100%;
    padding-right: rem-calc(18);
    max-width: unset;
  }

  .mSubCat4__link {
    padding-right: rem-calc(18);
  }

  .mSubCat4__item-label {
    width: calc(100% - 18px);
    padding: 0;
  }
}
</style>
